import { createClient } from 'laboratory-lib';
import { getExperimentsConfig } from './getExperimentsConfig';
import { getUserExperimentIdentifier } from './getUserExperimentIdentifier';
import { experimentsEnabled } from './experimentsEnabled';
import TrackerContainer from '../tracking/TrackerContainer';
import { getUtk } from 'usage-tracker-core/common/defaultTrackers';
import { hasAcceptedCookies } from '../tracking/cookieUtils';
export const getTreatmentsClient = () => {
  return createClient({
    name: 'signup-laboratory-client',
    timeout: 8000,
    experiments: getExperimentsConfig(),
    identifiers: Object.assign({
      portalId: null
    }, TrackerContainer.trackingByCookiePreferenceEnabled() && hasAcceptedCookies() ? {
      utk: getUtk(),
      other: getUserExperimentIdentifier()
    } : {
      utk: getUserExperimentIdentifier(),
      other: getUserExperimentIdentifier()
    }),
    // if the experiments are disabled, we want to get default treatments back from laboratory
    mode: experimentsEnabled() ? 'default' : 'cache-only'
  });
};